export const addAlpha = (color: string, opacity: number) => {
  const opacityToUse = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);

  return color + opacityToUse.toString(16).toUpperCase();
};
